<template>
  <v-row>
    <v-col v-if="admin">
      <v-icon @click="dialog=true" color="red">mdi-pencil</v-icon>
    </v-col>

    
    <v-col cols="12">
       <v-text-field 
        label="descrizione"
        v-model="dati.descrizionetemplate"></v-text-field>
    </v-col>
     <v-col cols="12">
       <v-btn @click="Salva">salva</v-btn>
    </v-col>
  </v-row>
</template>

<script>

export default {
  components: {},
  props: ["list", "admin"],
  model: {
    prop: "list",
    event: "listchange"
  },
  computed: {
    listLocal: {
      get: function() {
        return this.list;
      },
      set: function(value) {
        console.log("set lista",value)
        this.$emit("listchange", value);
      }
    },
    templ:{
      get: function(){
        return this.$store.state.preventivo
      }
      
    }
    
  },
  data: () => ({
    dialog: false,
    dati:{
        idcliente:'cli1',
        id:'',
        descrizionetemplate:''
    }
  }),

  methods: {
    updateValue: function() {
      this.dialog = false;
      this.$emit("input", this.value);
    },
    Salva(){
      this.$store.dispatch("saveAsTemplate",this.dati)
    }
  }
};
</script>